import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	panel: {
		width: "100%",
		paddingTop: theme.spacing(1),
	},
}));

const TabPanel = ({ children, value, name, ...rest }) => {
	const classes = useStyles();

  if (value === name) {
    return (
      <div
        className={classes.panel}
        role="tabpanel"
        id={`simple-tabpanel-${name}`}
        aria-labelledby={`simple-tab-${name}`}
        {...rest}
      >
        <>{children}</>
      </div>
    );
  } else return null;
};

export default TabPanel;
